import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const fields: ThemeUICSSObject = {
  /* PREPEND HERE */
};

export default fields;
